import React from 'react';
import './UnitedPlaceholder.css';

const UnitedPlaceholder: React.FC = () => {
  return (
    <div className="united-placeholder">
      <img
        src="/united-total.png"
        alt="United Airlines App Mockup"
        className="united-image"
        data-reveal-hero
      />
    </div>
  );
};

export default UnitedPlaceholder;
